var React = require('react');

function HygeneIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M120 49.7143C120 47.5051 118.209 45.7143 116 45.7143H74.2857V4C74.2857 1.79087 72.4949 0 70.2857 0H49.7143C47.5051 0 45.7143 1.79086 45.7143 4V45.7143H4C1.79087 45.7143 0 47.5051 0 49.7143V70.2857C0 72.4949 1.79086 74.2857 4 74.2857H45.7143V116C45.7143 118.209 47.5051 120 49.7143 120H70.2857C72.4949 120 74.2857 118.209 74.2857 116V74.2857H116C118.209 74.2857 120 72.4949 120 70.2857V49.7143ZM114.286 68.5714H74.2857H68.5714V74.2857V114.286H51.4286V74.2857V68.5714H45.7143H5.71429V51.4286H45.7143H51.4286V45.7143V5.71429H68.5714V45.7143V51.4286H74.2857H114.286V68.5714Z","fill":"white"}));
}

HygeneIcon.defaultProps = {"width":"120","height":"120","viewBox":"0 0 120 120","fill":"none"};

module.exports = HygeneIcon;

HygeneIcon.default = HygeneIcon;
